import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Brain = function Brain(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11 40C7.6875 40 5 37.3125 5 34C5 32.0625 5.9375 30.2375 7.5125 29.1125L8.675 30.7375C7.625 31.5 7 32.7125 7 34C7 36.2 8.8 38 11 38C13.2 38 15 36.2 15 34H17C17 37.3125 14.3125 40 11 40Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 21C8.1375 21 5 17.8625 5 14C5 10.1375 8.1375 7 12 7C12.8 7 13.5875 7.1375 14.35 7.4L13.6875 9.2875C13.15 9.1 12.5875 9 12.0125 9C9.25 9 7.0125 11.2375 7.0125 14C7.0125 16.7625 9.25 19 12.0125 19V21H12Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 46C15.6875 46 13 43.3125 13 40C13 38.6625 13.425 37.4 14.2375 36.35L15.825 37.5625C15.2875 38.2625 15 39.1 15 39.9875C15 42.1875 16.8 43.9875 19 43.9875C21.2 43.9875 23 42.1875 23 39.9875V8C23 5.8 21.2 4 19 4C16.8 4 15 5.8 15 8C15 10.2 16.8 12 19 12V14C15.6875 14 13 11.3125 13 8C13 4.6875 15.6875 2 19 2C22.3125 2 25 4.6875 25 8V40C25 43.3125 22.3125 46 19 46Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 31C5.1375 31 2 27.8625 2 24C2 20.7125 4.2375 17.9 7.45 17.175L7.8875 19.125C5.6375 19.6375 4 21.6875 4 24C4 26.7625 6.2375 29 9 29C10.975 29 12.7625 27.8376 13.5625 26.0375L15.3875 26.85C14.2625 29.375 11.75 31 9 31Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M37 40C33.6875 40 31 37.3125 31 34H33C33 36.2 34.8 38 37 38C39.2 38 41 36.2 41 34C41 32.7125 40.375 31.5 39.325 30.75L40.4875 29.125C42.0625 30.25 43 32.075 43 34.0125C43 37.3125 40.3125 40 37 40Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M36.0001 21V19C38.7626 19 41.0001 16.7625 41.0001 14C41.0001 11.2375 38.7626 9 36.0001 9C35.4251 9 34.8626 9.1 34.3251 9.2875L33.6626 7.4C34.4126 7.1375 35.2001 7 36.0126 7C39.8751 7 43.0126 10.1375 43.0126 14C43.0126 17.8625 39.8626 21 36.0001 21Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M29 46C25.6875 46 23 43.3125 23 40H25C25 42.2 26.8 44 29 44C31.2 44 33 42.2 33 40C33 39.1125 32.7125 38.2751 32.175 37.5751L33.7625 36.3625C34.575 37.4125 35 38.6751 35 40.0126C35 43.3126 32.3125 46 29 46Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M29 14V12C31.2 12 33 10.2 33 8C33 5.8 31.2 4 29 4C26.8 4 25 5.8 25 8H23C23 4.6875 25.6875 2 29 2C32.3125 2 35 4.6875 35 8C35 11.3125 32.3125 14 29 14Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M39.0003 31C36.2503 31 33.7378 29.375 32.6128 26.8625L34.4378 26.05C35.2378 27.85 37.0378 29.0125 39.0003 29.0125C41.7628 29.0125 44.0003 26.775 44.0003 24.0125C44.0003 21.7 42.3628 19.65 40.1128 19.1375L40.5503 17.1875C43.7628 17.9125 46.0003 20.725 46.0003 24.0125C46.0003 27.8625 42.8628 31 39.0003 31Z",
      fill: color
    })]
  });
};
export default Brain;